/**
 * index.tsx
 *
 * Author: Maurice T. Meyer
 * E-Mail: maurice@lavireo.com
 *
 * (c) Laviréo. All rights reserved.
 *
 * This document is the property of Laviréo.
 * It is considered confidential and proprietary.
 *
 * This document may not be reproduced or transmitted in any form,
 * in whole or in part, without the express written permission of
 * Laviréo.
 */

import { FC }         from 'react';
import { LabelProps } from './types';
import { styles }     from './styles';

export const Label: FC<LabelProps> = ({ info, children }) => (
  <div css={styles.container}>
    <span css={styles.label}>
      {children}
    </span>
    { info &&
      <button css={styles.info} type="button" />
    }
  </div>
);